import careerIconUrl from '@/assets/app-icon-presets/career.png'
import codingIconUrl from '@/assets/app-icon-presets/coding.png'
import gradingIconUrl from '@/assets/app-icon-presets/grading.png'
import illustrationIconUrl from '@/assets/app-icon-presets/illustration.png'
import languageIconUrl from '@/assets/app-icon-presets/language.png'
import learningIconUrl from '@/assets/app-icon-presets/learning.png'
import meetingIconUrl from '@/assets/app-icon-presets/meeting.png'
import presentationIconUrl from '@/assets/app-icon-presets/presentation.png'
import promotionIconUrl from '@/assets/app-icon-presets/promotion.png'
import promptIconUrl from '@/assets/app-icon-presets/prompt.png'
import questionsIconUrl from '@/assets/app-icon-presets/questions.png'
import writingIconUrl from '@/assets/app-icon-presets/writing.png'

export interface AppIconPreset {
  avatar: string
  id: string
  labelKey: string
}

const presetIconUrls = {
  career: careerIconUrl,
  coding: codingIconUrl,
  grading: gradingIconUrl,
  illustration: illustrationIconUrl,
  language: languageIconUrl,
  learning: learningIconUrl,
  meeting: meetingIconUrl,
  presentation: presentationIconUrl,
  promotion: promotionIconUrl,
  prompt: promptIconUrl,
  questions: questionsIconUrl,
  writing: writingIconUrl,
} as const

const presetOrder = [
  'presentation',
  'grading',
  'learning',
  'questions',
  'promotion',
  'writing',
  'illustration',
  'language',
  'meeting',
  'career',
  'prompt',
  'coding',
] as const

export const appIconPresets: AppIconPreset[] = presetOrder.map((id) => ({
  avatar: presetIconUrls[id],
  id,
  labelKey: `drawer.iconPicker.presets.${id}`,
}))
